"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@mui/styles");
exports.useStyles = (0, styles_1.makeStyles)(theme => ({
    "flex-end": {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(0),
        "&:first-child": {
            marginLeft: 0,
        },
        "&:last-child": {
            marginRight: 0,
        },
    },
    center: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        "&:first-child": {
            marginLeft: 0,
        },
        "&:last-child": {
            marginRight: 0,
        },
    },
    "flex-start": {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(2),
        "&:first-child": {
            marginLeft: 0,
        },
        "&:last-child": {
            marginRight: 0,
        },
    },
    "space-between": {},
    "space-around": {},
    "space-evenly": {},
}), { name: "ButtonToolbar" });
//# sourceMappingURL=styles.js.map